<template>
  <div class="product-container">
    <product-form v-if="editingProduct" :product="editingProduct" ></product-form>
    <div class="product-list" v-else>
      <md-table-card>

        <md-toolbar>
          <md-layout class="list-header">

            <md-layout>
              <md-button @click.native="clickCreate()" class="md-icon-button md-raised md-warn">
                <md-icon>add</md-icon>
              </md-button>
            </md-layout>

            <md-layout>
              <translate tag="h1" class="md-title">Products</translate>
            </md-layout>

            <md-layout md-align="end">
              <!-- <md-button class="md-icon-button">
                <md-icon>search</md-icon>
              </md-button> -->
              <md-button @click.native="fetchProducts()" class="md-icon-button">
                <md-icon>refresh</md-icon>
              </md-button>
            </md-layout>

          </md-layout>
        </md-toolbar>

        <md-card-area class="products-card-area">
          <product-card v-for="product in allProducts" :key="product._id" :product="product"></product-card>
        </md-card-area>

      </md-table-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import ProductCard from './Card'
import ProductForm from './Form'

export default {
  name: 'product-list',
  data () {
    return {
      products: []
    }
  },
  async created () {
    await this.fetchProducts()

    if (this.editId) {
      this.productEdit(this.editId)
    }
    if (this.create) {
      this.productCreate()
    }
  },
  // props from Admin Dashboard indicating whether we need to open Form to edit item or create a new one
  props: ['create', 'editId'],
  watch: {
    editId (val) {
      if (val) {
        this.productEdit(val)
      } else {
        this.productCancelEdit()
      }
    },
    create (val) {
      if (val) {
        this.productCreate()
      } else {
        this.productCancelEdit()
      }
    }
  },
  computed: {
    ...mapGetters([
      'allProducts',
      'editingProduct'
    ])
  },
  methods: {
    ...mapMutations([
      'productEdit',
      'productCreate',
      'productCancelEdit'
    ]),
    ...mapActions([
      'fetchProducts'
    ]),
    clickCreate () {
      this.$router.push({ name: 'tab-2-create' })
      this.productCreate()
    }
  },
  components: {
    ProductCard,
    ProductForm
  }
}
</script>

<style>
.products-card-area {
  text-align: left;
  padding-top: 10px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/products/List.vue